import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading font-bold text-primary-500">6080</span>
              <span className="text-lg font-heading text-foreground-800">影院</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              6080影院汇集高清电影免费看和免费电视剧全集，高清在线影院级画质，免费影视大全无需付费，高清视频播放流畅不卡。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">影片分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-500">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@6080cinema.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-500"></i>
                <span>在线客服 7×24小时</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-primary-500"></i>
                <span>安全绿色无广告</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 6080影院 - 高清电影免费看 | 免费电视剧全集 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}